module.exports = __webpack_public_path__ + "static/media/almadar-wide-logo.67cb0831.png";